import CorporateTransportationSubmissionsResource from "./corporateTransportationSubmissions.resource";

const corporateTransportationSubmissionsModule = angular
  .module("app.resources.corporateTransportationSubmissions", [])
  .service(
    "CorporateTransportationSubmissions",
    CorporateTransportationSubmissionsResource
  );

export default corporateTransportationSubmissionsModule;



// WEBPACK FOOTER //
// ./src/resources/corporateTransportationSubmissions/corporateTransportationSubmissions.module.js